import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ProdData } from './prod-dto';

export class ProdInvResponseModel extends GlobalResponseObject{
    data?: ProdData;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProdData
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ProdData) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
